import FileInputDragDrop from './FileInputDragDrop';

export default FileInputDragDrop;
